import { render, staticRenderFns } from "./EventDetectionHR.vue?vue&type=template&id=0959a89b"
import script from "./EventDetectionHR.vue?vue&type=script&lang=js"
export * from "./EventDetectionHR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports